import React, { Component } from "react";
import { Grid, Dialog, DialogContent, TableCell, TableRow, TableBody, Table, DialogActions, BottomNavigation, BottomNavigationAction, Button } from "@material-ui/core";
import AppBarModal from "../../general/AppBarModal";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import LoopIcon from "@material-ui/icons/Loop";
import FormatListIcon from "@material-ui/icons/FormatListNumberedRtl";
import SyncIcon from "@material-ui/icons/Sync";
import TareasTerminadas from "../../general/TareasTerminadas";
import { BtnForm, BtnCancelar } from "../../general/BotonesAccion";
import ListarDatos from "../../general/ListarDatos";
import { consulta, generarFiltros } from "../../../global/js/funciones";
import ConfirmarAccion from "../../general/ConfirmarAccion";
import { CLASE_TABLA_DETALLE } from "../../general/Detalle";

import { FormControl, Select, MenuItem, FormHelperText, IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import BuscarAsignatura from "./BuscarAsignatura";

//imagenes
import emma_w from '../../../global/imagenes/emma_w.png';
import moment from "moment";

const API_URI = `api/v1.0/invitadosVirtual/`;


function Menu({ sele = "detalle", seleccionar = () => { }, admin = false }) {
  const clase = (item, selec, tipo = '') => item === selec ? `item_selec${tipo}` : `item_modulo`;

  const pintar = (claseN = '') => {
    return (
      <div className={claseN}>
        <BottomNavigation showLabels style={{ justifyContent: "center", overflowX: "auto" }}>
          <BottomNavigationAction label={'Detalle'} icon={<ImportContactsIcon className='menu_icono' />} className={clase("detalle", sele)} onClick={() => seleccionar("detalle")} />
          <BottomNavigationAction label={'Estados'} icon={<LoopIcon className='menu_icono' />} className={clase("estados", sele)} onClick={() => seleccionar("estados")} />
          <BottomNavigationAction label={'Asignatura'} icon={<FormatListIcon className='menu_icono' />} className={clase("asignatura", sele)} onClick={() => seleccionar("asignatura")} />
          {admin && <BottomNavigationAction label={'Canvas'} icon={<SyncIcon className='menu_icono' />} className={clase("logs_canvas", sele)} onClick={() => seleccionar("logs_canvas")} />}
        </BottomNavigation>
      </div>
    )
  }

  return (
    <div>
      {pintar('menu_modal')}
    </div>
  );
}

class SolicitudDetalle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clase: "",
      cargando: false,
      sele: "",
      seleccionar: "detalle",
      estados: [],
      asignaturas: [],
      logs_canvas: [],
      estadoCancelar: null,
      modalCancelar: false,
      modalAgregar: false,

      asignaturas_asig: [],
      asignatura_seleccionada: "",
      modal_quitar_asignatura: false
    }
  }

  pintar = (data) => {
    let { seleccionar } = this.state;
    switch (seleccionar) {
      case "detalle":
        return this.pintarDetalle(data);
      case "estados":
        return this.pintarEstados();
      case "asignatura":
        return this.pintarAsignaturas();
      case "logs_canvas":
        return this.pintarLogsCanvas();
      default:
        break;
    }
  };

  async componentDidUpdate({ modalRespuestas }, { seleccionar }) {
    let { seleccionar: seleccionarNew } = this.state
    let { data } = this.props;
    if (seleccionarNew !== seleccionar) {
      if (seleccionarNew === 'detalle') await this.pintarDetalle(data);
      else if (seleccionarNew === 'estados') await this.obtenerEstados(data.id);
      else if (seleccionarNew === 'asignatura') await this.obtenerAsignatura(data.id);
      else if (seleccionarNew === 'logs_canvas') await this.obtenerLogsCanvas(data.id);
    }
  }


  async obtenerEstados(id) {
    this.setState({ cargando: true });
    let f = await generarFiltros([{ llave: "solicitud", valor: id }]);
    consulta(`${API_URI}estados?${f}`, null, null, (error, estado, resp) => {
      if (estado === 200) this.setState({ cargando: false, estados: resp });
    });
  }

  async obtenerAsignatura(id) {
    this.setState({ cargando: true });
    let f = await generarFiltros([{ llave: "solicitud", valor: id }]);
    consulta(`${API_URI}getAsignaturas?${f}`, null, null, (error, estado, resp) => {
      if (estado === 200) this.setState({ cargando: false, asignaturas: resp });
    });
  }

  async obtenerLogsCanvas(id) {
    this.setState({ cargando: true });
    let f = await generarFiltros([{ llave: "solicitud", valor: id }]);
    consulta(`${API_URI}logs_canvas?${f}`, null, null, (error, estado, resp) => {
      if (!error && estado === 200) this.setState({ cargando: false, logs_canvas: resp });
      else this.setState({ cargando: false, logs_canvas: [] });
    });
  }

  pintarLogsCanvas = () => {
    let { logs_canvas } = this.state;

    const obtenerColor = (resultado) => {
      let color = 'white';

      const colores = {
        'EXITO': { 'backgroundColor': '#009688', color },
        'ADVERTENCIA': { 'backgroundColor': '#ffc107', color },
        'ERROR': { 'backgroundColor': '#b71c1c', color },
      };

      return colores[resultado] || { 'backgroundColor': '#f5f5f5', 'color': '#757575' };
    };

    const marcas = { 'EXITO': '✓', 'ADVERTENCIA': '!', 'ERROR': '✕' };

    return (
      <ListarDatos
        datos={logs_canvas}
        titulo="Historial Canvas"
        id="tbl_logs_canvas"
        opciones={true}
        buscar={true}
        descargar="EMMA - HISTORIAL CANVAS"
        mensajeVacio="Esta solicitud no tiene registros de sincronización con Canvas"
        avatarImg={false}
        avatar={({ resultado }) => marcas[resultado] || '?'}
        color_avatar={({ resultado }) => obtenerColor(resultado)}
        fila_principal={({ operacion_nombre, codigo_asignatura }) =>
          codigo_asignatura ? `${operacion_nombre} - ${codigo_asignatura}` : operacion_nombre
        }
        filas={[
          {
            mostrar: ({ mensaje }) => mensaje,
            id: "mensaje",
            enLista: true,
          },
          {
            mostrar: ({ causa }) => causa,
            id: "causa",
            enLista: true,
          },
          {
            mostrar: ({ nombre_asignatura }) => nombre_asignatura,
            id: "nombre_asignatura",
            enLista: true,
          },
          {
            mostrar: ({ persona_registra }) =>
              persona_registra
                ? `${persona_registra["primer_nombre"]} ${persona_registra["primer_apellido"]}`.toUpperCase()
                : "",
            id: "persona_registra",
            enLista: true,
          },
          {
            mostrar: ({ fecha_registra }) => moment(fecha_registra).format('YYYY-MM-DD, h:mm a'),
            id: "fecha_registra",
            enLista: true,
          },
        ]}
      />
    );
  }

  pintarEstados = () => {
    let { estados } = this.state;

    const obtenerColor = (codigo) => {
      let color = 'white';

      const colores = {
        'Est_IVir_Ini': { 'backgroundColor': '#f5f5f5', 'color': '#757575' },
        'Est_IVir_Trami': { 'backgroundColor': '#ffc107', color },
        'Est_IVir_Asig_Cursar': { 'backgroundColor': '#01519B', color },
        'Est_IVir_Neg': { 'backgroundColor': '#b71c1c', color },
        'Est_IVir_Fin': { 'backgroundColor': '#009688', color },
        'Tod_Inv_Vir': { 'backgroundColor': '#0d47a1', color },
      };

      return colores[codigo];
    };

    return (
      <ListarDatos
        datos={estados}
        titulo="Estados"
        id="tbl_estados"
        buscar={true}
        avatar={({ estado_solicitud }) => `${estado_solicitud["valora"]}`}
        color_avatar={({ estado_solicitud: { codigo } }) => obtenerColor(codigo)}
        fila_principal={({ estado_solicitud }) =>
          `${estado_solicitud["nombre"]}`
        }
        filas={[
          {
            mostrar: ({ persona_registra }) =>
              `${persona_registra["primer_nombre"]} ${persona_registra["segundo_nombre"]} ${persona_registra["primer_apellido"]} ${persona_registra.segundo_apellido}`.toUpperCase(),
            id: "nombre_completo",
            enLista: true,
          },
          {
            mostrar: ({ fecha_registra }) => moment(fecha_registra).format('YYYY-MM-DD, h:mm a'),
            id: "fecha_registra",
            enLista: true,
          },
          {
            mostrar: ({ observaciones }) => observaciones,
            id: "observaciones",
            enLista: true,
          },
        ]}
      />
    );
  }

  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({
      [name]: value,
    });
  };

  pintarMostrarAsignaturas() {
    let { asignaturas_asig, asignatura_seleccionada, modal_buscar_asignatura, modal_quitar_asignatura } = this.state;
    let seleccionada = asignatura_seleccionada ? asignaturas_asig.find(asign => asign.id === asignatura_seleccionada) : { id: 0 };
    const onClickEliminar = (data) => {
      if (data) this.setState({ modal_quitar_asignatura: true });
    };
    const quitarAsignaturaSeleccionada = (id) => {
      if (id) {
        this.setState({
          asignaturas_asig: asignaturas_asig.filter((inst) => inst.id !== id),
          asignatura_seleccionada: "",
          modal_quitar_asignatura: false,
        });
      }
    };
    return (
      <Grid container spacing={2}>
        <Grid item>
          <FormControl className='form-control' required>
            <Select sx={{ maxWidth: 300 }} id='asignatura_seleccionada' name='asignatura_seleccionada' value={asignatura_seleccionada} displayEmpty onChange={this.onChange}>
              <MenuItem value="">
                <em>{`${asignaturas_asig.length} Asignatura(s) seleccionada(s)`}</em>
              </MenuItem>
              {asignaturas_asig.map((inst) => <MenuItem key={inst.id} value={inst.id}>{inst.nombre.toUpperCase()}</MenuItem>)}
            </Select>
          </FormControl>
          <FormHelperText></FormHelperText>
        </Grid>
        <Grid >
          <BuscarAsignatura
            seleccionar={({ id, nombre }) => { this.setState({ asignaturas_asig: asignaturas_asig.concat({ id: id, nombre: nombre }) }) }}
            quitar={({ id }) => { this.setState({ asignaturas_asig: asignaturas_asig.filter(asign => asign.id !== id) }) }}
            seleccionadas={asignaturas_asig}
            modalBuscarAsignatura={modal_buscar_asignatura}
            mostrarModalBuscar={(modal_buscar_asignatura) => this.setState({ modal_buscar_asignatura })}
          />
          <ConfirmarAccion
            mensaje1={asignatura_seleccionada && `Se quitará ${seleccionada.nombre} de la lista, `}
            ejecutarAccion={quitarAsignaturaSeleccionada}
            mostrarModalConfAccion={(modal_quitar_asignatura) => this.setState({ modal_quitar_asignatura })}
            modalConAccion={modal_quitar_asignatura}
            dato={asignatura_seleccionada ? seleccionada : { id: 0 }}
            titulo={'¿ Quitar Asignatura ?'}
          />
          <IconButton aria-label="add" onClick={() => this.setState({ modal_buscar_asignatura: true })}>
            <AddIcon />
          </IconButton>
          <IconButton aria-label="delete" onClick={() => onClickEliminar(asignatura_seleccionada)}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      </Grid>
    );
  }

  onAsignar = async (e) => {
    let { asignaturas_asig } = this.state;
    if (asignaturas_asig.length > 0) {
      let { data, agregarAsignatura } = this.props;
      await agregarAsignatura(data.id, asignaturas_asig, () => {
        this.setState({ cargando: false, modalAgregar: false, asignaturas_asig: [], asignatura_seleccionada: ""})
        this.obtenerAsignatura(data.id)
      });
    }
    e.preventDefault();
  };

  pintarAsignaturas = () => {
    let { eliminarAsignatura, data: { estado_solicitud, id: idAsign }, admin } = this.props
    let { estadoCancelar, modalAgregar } = this.state

    const callback = () => {
      this.setState({ modalCancelar: false })
      this.obtenerAsignatura(idAsign)
    }

    const acciones = (asignatura) => {

      const onClickGestionar = id => {
        this.setState({ estadoCancelar: id, modalCancelar: true })
      }
      let detalle = ((estado_solicitud.codigo == "Est_IVir_Asig_Cursar" || estado_solicitud.codigo == "Est_IVir_Fin") && admin) ? <BtnCancelar callback={() => onClickGestionar(asignatura.id)} color='#900807' texto='Eliminar' /> : '';
      return detalle
    }


    let { asignaturas, modalCancelar } = this.state;
    return (
      <>
        <ListarDatos
          datos={asignaturas}
          titulo="Asignaturas"
          id="tbl_asignaturas"
          buscar={true}
          acciones={(row) => acciones(row)}
          avatarImg={false}
          avatar={({ asignatura }) => `${asignatura["nombre"]}`.charAt(0)}
          fila_principal={({ asignatura }) => `${asignatura["nombre"]}`}
          agregar={((estado_solicitud.codigo == "Est_IVir_Asig_Cursar" || estado_solicitud.codigo == "Est_IVir_Fin") && admin) ? true : false}
          actAgregar={() => this.setState({ modalAgregar: true })}
          filas={[
            {
              mostrar: ({ asignatura }) => asignatura.codigo,
              id: "codigo",
              enLista: true,
            },
            {
              mostrar: ({ persona_registra }) =>
                `${persona_registra["primer_nombre"]} ${persona_registra["segundo_nombre"]} ${persona_registra["primer_apellido"]} ${persona_registra.segundo_apellido}`.toUpperCase(),
              id: "nombre_completo",
              enLista: true,
            },
            {
              mostrar: ({ fecha_registra }) =>
                moment(fecha_registra).format("YYYY-MM-DD, h:mm a"),
              id: "fecha_registra",
              enLista: true,
            },
          ]}
        />
        <ConfirmarAccion
          dato={{ id: 0 }}
          titulo={' ¿ Eliminar Asignatura ?'}
          ejecutarAccion={() => eliminarAsignatura(estadoCancelar, callback)}
          modalConAccion={modalCancelar}
          mostrarModalConfAccion={() => this.setState({ modalCancelar: false })}
        />


        <Dialog fullWidth={true} maxWidth="sm" open={modalAgregar} onClose={() => this.setState({ modalAgregar: false })} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
          <AppBarModal titulo={"¿ Agregar Asignatura ?"} mostrarModal={() => this.setState({ modalAgregar: false })} titulo_accion="" accion="" />
          <DialogContent style={{ padding: "1" }} className="scroll">
            {this.pintarMostrarAsignaturas()}
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CERRAR" callback={() => this.setState({ modalAgregar: false })} />
            <BtnForm texto="ACEPTAR" callback={this.onAsignar} />
          </DialogActions>
        </Dialog>
      </>
    );
  }

  pintarDetalle = (data) => {
    return (
      <Grid container>
        <Grid item xs={12} md={12}>
          <Table className={CLASE_TABLA_DETALLE}>
            <TableBody>
              <TableRow key={1}>
                <TableCell component="th" scope="row">Nombre del Solicitante</TableCell>
                <TableCell align="left">{(data.length !== 0) ? data["persona"]["primer_nombre"] + " " + data["persona"]["primer_apellido"] + " " + data["persona"]["segundo_apellido"] : ""}</TableCell>
              </TableRow>

              <TableRow key={2}>
                <TableCell component="th" scope="row">Número de identificación</TableCell>
                <TableCell align="left">{(data.length !== 0) ? data["persona"]["identificacion"] : ""}</TableCell>
              </TableRow>

              <TableRow key={3}>
                <TableCell component="th" scope="row">Correo Electronico</TableCell>
                <TableCell align="left">{(data.length !== 0) ? data["persona"]["correo_personal"] : ""}</TableCell>
              </TableRow>

              <TableRow key={4}>
                <TableCell component="th" scope="row">Celular/Telefono</TableCell>
                <TableCell align="left"> {(data.length !== 0) ? data["persona"]["celular"] : ""} </TableCell>
              </TableRow>

              <TableRow key={5}>
                <TableCell component="th" scope="row">Programa academico</TableCell>
                <TableCell align="left">{(data.length !== 0) ? data["programa"]["nombre"] : ""}</TableCell>
              </TableRow>

              <TableRow key={6}>
                <TableCell component="th" scope="row">Tipo Estudiante</TableCell>
                <TableCell align="left">{(data.length !== 0) ? data["tipo_solicitud"]["nombre"] : ""}</TableCell>
              </TableRow>

              <TableRow key={7}>
                <TableCell component="th" scope="row">Periodo</TableCell>
                <TableCell align="left">{(data.length !== 0) ? data.periodo : ""}</TableCell>
              </TableRow>

              <TableRow key={8}>
                <TableCell component="th" scope="row">Fecha Solicitud</TableCell>
                <TableCell align="left">{(data.length !== 0) ? moment(data["fecha_registra"]).format("YYYY-MM-DD, h:mm a") : ""}</TableCell>
              </TableRow>

              <TableRow key={9}>
                <TableCell component="th" scope="row">Estado Solicitud</TableCell>
                <TableCell align="left">{(data.length !== 0) ? data["estado_solicitud"]["nombre"] : ""}</TableCell>
              </TableRow>
            </TableBody>

            <TableRow key={10}>
                <TableCell component="th" scope="row">Estado Pago Matrícula</TableCell>
                <TableCell align="left">{(data.length !== 0) ? (data.pago_matricula === "1" ? "PAGADO" : "NO PAGO") : ""}</TableCell>
              </TableRow>
          </Table>
        </Grid>
      </Grid>
    )
  }

  handleClose = () => {
    let { closeModal } = this.props;
    this.setState({ seleccionar: "detalle" });
    closeModal(false);
  };


  render() {
    let { data, openModal, admin } = this.props;
    let { cargando, seleccionar } = this.state;
    return (
      <div>
        <Dialog onClose={this.handleClose} open={openModal} fullWidth={true} fullScreen={window.innerWidth < 600} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <AppBarModal titulo={'Detalle Solicitud'} mostrarModal={this.handleClose} titulo_accion="Cerrar" />
          <DialogContent className="scroll" style={{ padding: 0 }}>
            <Menu sele={seleccionar} seleccionar={(seleccionar) => this.setState({ seleccionar })} admin={admin} />
            {!cargando ? this.pintar(data) : <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" />}
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleClose} color="primary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }

}

export default SolicitudDetalle;